export default __webpack_public_path__ + "static/media/lotto.b9ede271.png";